// Modal web component, with smooth animation and keyboard support
    const template = document.createElement('template');
    template.innerHTML = `
      <style>
      :host {
        display: block;
      }
      
      .modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        display: none;
        background: rgba(0, 0, 0, 0.5);
      }
      .modal-body {
        overflow: auto;
        position: absolute;
        bottom: 0px;
        left: 0px;
        height: 65vh;
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        background: #fff;
        padding: 1.4rem;
        box-sizing: border-box;
        box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.2);
      }
      
      
      </style>
      <div class="modal">
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
      </div>
    `;
  
    class Modal extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.modal = this.shadowRoot.querySelector('.modal');

        // Close modal when clicking outside the modal
        this.modal.addEventListener('click', e => {
          if (e.target === this.modal) {
            this.close();
          }
        });

  
       // Close modal when pressing the escape key
        document.addEventListener('keydown', e => {
          if (e.key === 'Escape') {
            this.close();
          }
        });
        this.classList.remove('js-hidden');
      }

      // Public method to open the modal
      open() {
        this.modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
  
      // Public method to close the modal
      close() {
        this.modal.style.display = 'none';
        document.body.style.overflow = 'auto';
      }
    }

    window.customElements.define('modal-component', Modal);